import { Link, useLocation } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Col } from "reactstrap";
import FeatherIcons from "../FeatherIcon/FeatherIcons";
import H4 from "../Headings/H4Element";

const CommonBreadcrumb = () => {
  const location = useLocation();
  const [firstPart, secondPart, thirdPart] = location.pathname
    .split("/")
    .slice(1);

    console.log(location.pathname, secondPart)
  return (
    <Col xs="4" xl="4" className="page-title">
      {
        secondPart === 'user-management' ? (<>
          <H4 className="f-w-700 text-capitalize">
            User Details
          </H4>
        </>) : (<>
        <H4 className="f-w-700 text-capitalize">
          {thirdPart
            ? thirdPart.replaceAll("_", " ")
            : secondPart.replaceAll("_", " ")}
        </H4>
        </>)
      }
      <Breadcrumb>
        <BreadcrumbItem>
          <Link to={`/payment-management`}>
            <FeatherIcons iconName="Home" />
          </Link>
        </BreadcrumbItem>
        <BreadcrumbItem className="f-w-400 text-capitalize">
          {firstPart.replaceAll("_", " ")}
        </BreadcrumbItem>
        <BreadcrumbItem className={`f-w-400 ${!thirdPart ? "active" : ""}`}>
          {secondPart.replaceAll("_", " ")}
        </BreadcrumbItem>
        {secondPart !== 'user-management' && (<>
          {thirdPart && (
            <BreadcrumbItem className="f-w-400 active">
              {thirdPart.replaceAll("_", " ")}
            </BreadcrumbItem>
          )}
        </>)}
        
      </Breadcrumb>
    </Col>
  );
};

export default CommonBreadcrumb;
